export const ACCESS_TOKEN = "access";
export const REFRESH_TOKEN = "refresh"
export const CSRF_TOKEN = "csrftoken";